const getFormatedDate = (dateValue)=>{
    const DateValue = new Date(dateValue);
    const shortMonth = DateValue.toLocaleString("en-US", {
      month: "short",
    });
    const day = DateValue.toLocaleString("en-US", {
      day: "numeric",
    });
    const year = DateValue.toLocaleString("en-US", {
      year: "numeric",
    });
    const finaldate = shortMonth + "-" + day + "-" + year;
    return finaldate;
}
export default getFormatedDate;